import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '../../elementals/icon';
import PopupTooltip from '../../overlays/popupTooltip';
import { ColorNames } from '../../../constants/colorVars';
const PendingTooltip = ({ style }) => (_jsx(PopupTooltip, { content: 'This field is not editable until the previous change to it is resolved by our team.', wide: false, position: 'top left', trigger: _jsx(Icon, { name: 'hourglass-half', iconStyle: 'solid', color: ColorNames.Caution, fitted: true, style: { paddingRight: 6, fontSize: 14, ...style } }) }));
export default PendingTooltip;
//# sourceMappingURL=pendingTooltip.js.map